<template>
    <div class="order-number-sequence-island dlm-admin-theme" data-testid="order-number-sequence-island">
        <div class="order-detail-v1__header-stripe">
            <div class="row">
                <div class="col-md-8">
                    <h1 class="order-detail-v1__header-title">
                        {{ label('title', 'Numerazione ordini') }}
                    </h1>
                    <p class="text-muted" style="margin-top: 8px;">
                        Contatore singleton senza cambio anno. BeeStore cap {{ status.cap }}.
                    </p>
                </div>
                <div class="col-md-4 text-right">
                    <div class="ons-remaining">
                        <div class="ons-remaining__value" :class="remainingClass">{{ status.remaining }}</div>
                        <div class="ons-remaining__label">{{ label('remaining', 'Numeri rimanenti') }}</div>
                        <div class="ons-remaining__meta">ultimo: {{ status.last_number }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="flash" class="alert" :class="flash.ok ? 'alert-success' : 'alert-danger'" role="status">
            {{ flash.text }}
        </div>

        <div class="row">
            <div class="col-md-6">
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4>{{ label('armed', 'Reset armato') }}</h4>
                    </div>
                    <div class="panel-body">
                        <template v-if="status.reset_pending">
                            <dl class="ons-dl">
                                <div><dt>{{ label('reset_to', 'Riparti da') }}</dt><dd>{{ status.reset_to }}</dd></div>
                                <div><dt>{{ label('effective_from', 'Valido dal') }}</dt><dd>{{ status.effective_from || '—' }}</dd></div>
                                <div><dt>Stato</dt><dd>In attesa — scatta il {{ status.effective_from || '…' }}</dd></div>
                            </dl>
                            <button
                                v-if="permissions.can_update"
                                type="button"
                                class="btn btn-warning"
                                :disabled="busy"
                                @click="onCancel"
                            >
                                {{ label('cancel', 'Annulla') }}
                            </button>
                        </template>
                        <p v-else class="text-muted">Nessun reset in attesa.</p>
                    </div>
                </div>

                <div v-if="permissions.can_update" class="panel panel-default">
                    <div class="panel-heading"><h4>{{ label('arm', 'Arma') }}</h4></div>
                    <div class="panel-body">
                        <div class="form-group">
                            <label>{{ label('reset_to', 'Riparti da') }}</label>
                            <input v-model.number="form.reset_to" type="number" class="form-control" min="1" />
                        </div>
                        <div class="form-group">
                            <label>{{ label('effective_from', 'Valido dal') }}</label>
                            <input v-model="form.effective_from" type="datetime-local" class="form-control" />
                        </div>
                        <div class="checkbox">
                            <label>
                                <input v-model="form.confirm_crowded" type="checkbox" />
                                {{ label('confirm_crowded', 'Confermo nonostante la fascia affollata') }}
                            </label>
                        </div>
                        <button type="button" class="btn btn-primary" :disabled="busy" @click="onArm">
                            {{ label('arm', 'Arma') }}
                        </button>
                        <button
                            type="button"
                            class="btn btn-default"
                            data-testid="order-number-sequence-preview"
                            :disabled="busy"
                            @click="onPreview"
                            style="margin-left:8px;"
                        >
                            {{ label('collision', 'Anteprima collisioni') }}
                        </button>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="panel panel-default">
                    <div class="panel-heading"><h4>{{ label('collision', 'Anteprima collisioni') }}</h4></div>
                    <div class="panel-body">
                        <dl class="ons-dl">
                            <div><dt>Fascia</dt><dd>{{ preview.window_start }} – {{ preview.window_end }}</dd></div>
                            <div><dt>Occupati vivi</dt><dd :class="preview.crowded ? 'text-danger' : ''">{{ preview.occupied }}</dd></div>
                            <div><dt>Min / max vivi</dt><dd>{{ status.live_min }} / {{ status.live_max }}</dd></div>
                        </dl>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading"><h4>{{ label('safety_net', 'Rete di sicurezza') }}</h4></div>
                    <div class="panel-body">
                        <p>{{ status.safety_net_explanation }}</p>
                        <p class="text-muted">Avviso giornaliero sotto {{ status.warn_headroom }} numeri rimanenti.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="panel panel-default">
            <div class="panel-heading"><h4>{{ label('history', 'Storico') }}</h4></div>
            <div class="panel-body no-padding">
                <table class="table table-striped" style="margin:0;">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>reset_to</th>
                            <th>effective_from</th>
                            <th>status</th>
                            <th>reason</th>
                            <th>armed_at</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in status.history" :key="row.id">
                            <td>{{ row.id }}</td>
                            <td>{{ row.reset_to }}</td>
                            <td>{{ row.effective_from }}</td>
                            <td>{{ row.status }}</td>
                            <td>{{ row.reason }}</td>
                            <td>{{ row.armed_at }}</td>
                        </tr>
                        <tr v-if="!status.history?.length">
                            <td colspan="6" class="text-muted">Nessuno storico.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OrderNumberSequenceIsland',
    props: {
        initialPayload: { type: Object, required: true },
    },
    data() {
        return {
            payload: this.initialPayload,
            busy: false,
            flash: null,
            form: {
                reset_to: 1,
                effective_from: '',
                confirm_crowded: false,
            },
            preview: this.initialPayload?.status?.collision_preview || {
                occupied: 0,
                window_start: 1,
                window_end: 1,
                crowded: false,
            },
        };
    },
    computed: {
        status() {
            return this.payload.status || {};
        },
        permissions() {
            return this.payload.permissions || {};
        },
        remainingClass() {
            const warn = this.status.warn_headroom || 50000;
            return this.status.remaining < warn ? 'ons-remaining__value--warn' : '';
        },
    },
    methods: {
        label(key, fallback) {
            return (this.payload.labels && this.payload.labels[key]) || fallback;
        },
        csrf() {
            const el = document.querySelector('meta[name="csrf-token"]');
            return el ? el.getAttribute('content') : '';
        },
        async onPreview() {
            this.busy = true;
            this.flash = null;
            try {
                const url = new URL(this.payload.routes.preview, window.location.origin);
                url.searchParams.set('reset_to', String(this.form.reset_to || 1));
                const res = await fetch(url.toString(), { headers: { Accept: 'application/json' } });
                const json = await res.json();
                this.preview = json.preview || this.preview;
            } catch (e) {
                this.flash = { ok: false, text: e.message || 'Preview failed' };
            } finally {
                this.busy = false;
            }
        },
        async onArm() {
            this.busy = true;
            this.flash = null;
            try {
                const res = await fetch(this.payload.routes.arm, {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': this.csrf(),
                    },
                    body: JSON.stringify(this.form),
                });
                const json = await res.json();
                if (!res.ok) {
                    this.flash = { ok: false, text: json.message || 'Arm failed' };
                    return;
                }
                this.payload = json.payload;
                this.preview = json.preview || this.payload.status.collision_preview;
                this.flash = { ok: true, text: json.message };
            } catch (e) {
                this.flash = { ok: false, text: e.message || 'Arm failed' };
            } finally {
                this.busy = false;
            }
        },
        async onCancel() {
            this.busy = true;
            this.flash = null;
            try {
                const res = await fetch(this.payload.routes.cancel, {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'X-CSRF-TOKEN': this.csrf(),
                    },
                });
                const json = await res.json();
                if (!res.ok) {
                    this.flash = { ok: false, text: json.message || 'Cancel failed' };
                    return;
                }
                this.payload = json.payload;
                this.flash = { ok: true, text: json.message };
            } catch (e) {
                this.flash = { ok: false, text: e.message || 'Cancel failed' };
            } finally {
                this.busy = false;
            }
        },
    },
};
</script>

<style scoped>
.ons-remaining {
    background: #f7f7f7;
    border: 1px solid #ddd;
    padding: 16px;
    display: inline-block;
    min-width: 160px;
    text-align: center;
}
.ons-remaining__value {
    font-size: 32px;
    font-weight: 700;
    line-height: 1.1;
}
.ons-remaining__value--warn {
    color: #c9302c;
}
.ons-remaining__label {
    text-transform: uppercase;
    font-size: 11px;
    color: #777;
}
.ons-remaining__meta {
    margin-top: 4px;
    font-size: 12px;
}
.ons-dl {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px 16px;
    margin: 0 0 12px;
}
.ons-dl dt {
    font-size: 11px;
    text-transform: uppercase;
    color: #777;
    margin: 0;
}
.ons-dl dd {
    margin: 0;
    font-weight: 600;
}
</style>
